import type { JSX } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

/** Escalator glyph (Figma Football hub · "escalator"): four rising bars fading in toward the tallest. */
export const CustomEscalator = (props: SvgIconProps): JSX.Element => {
    return (
        <SvgIcon {...props} viewBox="0 0 20 20">
            <path
                opacity="0.3"
                d="M3 17C3 16.4477 3.44772 16 4 16V16C4.55228 16 5 16.4477 5 17V17C5 17.5523 4.55228 18 4 18V18C3.44772 18 3 17.5523 3 17V17Z"
            />
            <path
                opacity="0.5"
                d="M7 15C7 14.4477 7.44772 14 8 14V14C8.55228 14 9 14.4477 9 15V17C9 17.5523 8.55228 18 8 18V18C7.44772 18 7 17.5523 7 17V15Z"
            />
            <path
                opacity="0.7"
                d="M11 11C11 10.4477 11.4477 10 12 10V10C12.5523 10 13 10.4477 13 11V17C13 17.5523 12.5523 18 12 18V18C11.4477 18 11 17.5523 11 17V11Z"
            />
            <path d="M15 3C15 2.44772 15.4477 2 16 2V2C16.5523 2 17 2.44772 17 3V17C17 17.5523 16.5523 18 16 18V18C15.4477 18 15 17.5523 15 17V3Z" />
        </SvgIcon>
    );
};
